// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__N5RRp"};